/* eslint-disable react/no-children-prop */
import React from "react";
import { Tooltip } from "@foleon/atomic";
import { VscInfo } from "react-icons/vsc";

type TooltipContext = {
	text: string;
};

export const TooltipsTemplate = (props: TooltipContext) => {
	return (
		<Tooltip.Default children={<VscInfo size={30} />} text={props.text} />
	);
};

export default TooltipsTemplate;
